import type { UseQueryOptions } from '@tanstack/react-query';
import type { FolderPermission } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { FOLDER_PERMISSIONS_API_ROOT, FOLDERS_KEY } from '../constants';

export function getFolderPermissions(id: string): Promise<FolderPermission> {
  return FetchPromise.get(`${FOLDER_PERMISSIONS_API_ROOT}/${id}/permissions`);
}

export function useGetFolderPermissions(
  id: string,
  queryOptions: UseQueryOptions<FolderPermission, JQuery.jqXHR> = {},
) {
  return useQuery<FolderPermission, JQuery.jqXHR>([FOLDERS_KEY, id], () => getFolderPermissions(id), queryOptions);
}
